// ZERO COUNT FILTER HIDE
// Elrejti azokat a product_type filter elemeket, ahol a darabszám (0)

(function () {

  if (!window.location.pathname.includes('/collections')) return;

  function hideZeroFilters() {
    document.querySelectorAll('li').forEach(li => {
      const input = li.querySelector('input[name="filter.p.product_type"]');
      const span = li.querySelector('label span');

      if (!input || !span) return;

      const count = span.textContent.replace(/[()]/g, '').trim();

      if (count === '0') {
        li.style.display = 'none';
      }
    });
  }

  // első futás
  hideZeroFilters();

  // URL CHANGE WATCHER
  // Újrafuttatja a logikát URL változás után (Shopify filter reload)

  let lastUrl = location.href;

  new MutationObserver(() => {
    const currentUrl = location.href;

    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;

      setTimeout(() => {
        hideZeroFilters();
      }, 100);
    }
  }).observe(document, { subtree: true, childList: true });

})();


// SEKTOR BASED FILTER CONTROL
// URL-ben lévő szektor ID-k alapján szűri a felhasználási területek listáját (1 vagy 2 ID union, 3 = no filter)

(function () {
  const FILTER_NAME = 'filter.p.m.custom.felhasznalasi_ter';
  const FILTER_CONTAINER_SELECTOR = 'details[data-index="sidebar-filter.p.m.custom.felhasznalasi_ter"]';

  const SEKTOR_RULES = {
    '366046806280': [
      'Cafeteria',
      'Irodai munkatér',
      'Közösségi tér',
      'Recepció és váró',
      'Tárgyaló',
      'Udvar',
      'Vezetői iroda'
    ],
    '366047002888': [
      'Dolgozószoba',
      'Étkező',
      'Hálószoba',
      'Kert és terasz',
      'Nappali'
    ],
    '366046904584': [
      'Étterem/Bár',
      'Hotelszoba',
      'Klubszoba / szivarszoba',
      'Lobby',
      'Kültéri vendégtér',
      'Vendégház'
    ]
  };

  let containerObserver = null;
  let scheduled = false;

  function normalizeText(text) {
    return text.replace(/\s+/g, ' ').trim();
  }

  function getActiveSektorIds() {
    const url = location.href;
    return Object.keys(SEKTOR_RULES).filter(id => url.includes(id));
  }

  function getAllowedLabelsSet() {
    const activeIds = getActiveSektorIds();

    if (activeIds.length === 0) return null;
    if (activeIds.length === Object.keys(SEKTOR_RULES).length) return null;

    const merged = new Set();

    activeIds.forEach(id => {
      SEKTOR_RULES[id].forEach(label => merged.add(label));
    });

    return merged;
  }

  function getContainer() {
    return document.querySelector(FILTER_CONTAINER_SELECTOR);
  }

  function getItems(container) {
    if (!container) return [];

    return Array.from(container.querySelectorAll('li')).filter(li =>
      li.querySelector(`input[name="${FILTER_NAME}"]`)
    );
  }

  function getLabelText(li) {
    const label = li.querySelector('label');
    if (!label) return '';

    const clone = label.cloneNode(true);
    const span = clone.querySelector('span');
    if (span) span.remove();

    return normalizeText(clone.textContent);
  }

  function applyRules() {
    const container = getContainer();
    const items = getItems(container);
    const allowedLabels = getAllowedLabelsSet();

    items.forEach(li => {
      li.style.display = !allowedLabels || allowedLabels.has(getLabelText(li)) ? '' : 'none';
    });
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      setTimeout(() => {
        applyRules();
        scheduled = false;
      }, 80);
    });
  }

  function observeContainer() {
    const container = getContainer();

    if (containerObserver) {
      containerObserver.disconnect();
      containerObserver = null;
    }

    if (!container) return;

    containerObserver = new MutationObserver(scheduleApply);
    containerObserver.observe(container, {
      childList: true,
      subtree: true
    });
  }

  // STATE REFRESH
  // Újrafigyeli a DOM-ot és újraalkalmazza a szűrést URL vagy filter változáskor

  function refresh() {
    observeContainer();
    scheduleApply();
  }

  refresh();

  // HISTORY WATCHER
  // Shopify pushState / replaceState változások kezelése

  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    refresh();
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    refresh();
  };

  window.addEventListener('popstate', refresh);

  // DOM REBUILD WATCHER
  // Újrafuttatja a logikát, ha a theme újrarendereli a filter blokkot

  new MutationObserver(refresh).observe(document.body, {
    childList: true,
    subtree: true
  });

})();